import React from 'react';
import Table from '../../components/common/Table';
import { LogIn } from 'lucide-react';

interface MemberTableProps {
  data: any[];
  handleEdit: (service: any) => void;
  handleDelete: (service: any) => void;
  handleImpersonateLogin: (service: any) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const MemberTable: React.FC<MemberTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  handleImpersonateLogin,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Membership Number',
          key: 'membershipNumber',
        },
        {
          label: 'First Name',
          key: 'firstName',
        },
        {
          label: 'Last Name',
          key: 'lastName',
        },
        {
          label: 'Email',
          key: 'email',
        },
        {
          label: 'Phone',
          key: 'phone',
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
        extra: [
          {
            label: 'Login as member',
            icon: <LogIn/>,
            confirmMessage: 'Are you sure you want to login as this member?',
            onClick: handleImpersonateLogin
          }
        ]
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default MemberTable;
